/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAssetsTokens.vue?vue&type=template&id=9fcb8a16&scoped=true"
import script from "./popAssetsTokens.vue?vue&type=script&lang=js"
export * from "./popAssetsTokens.vue?vue&type=script&lang=js"
import style0 from "./popAssetsTokens.vue?vue&type=style&index=0&id=9fcb8a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcb8a16",
  null
  
)

export default component.exports